import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Segment } from 'semantic-ui-react';
import _ from 'lodash';
import log from 'loglevel';

import { Flex, Box } from 'src/Components/Base';
import { deptConverter } from 'src/GraphQL/query/DepartmentList.query';
import { convertScore } from 'src/GraphQL/query/Department.query';

import DepartmentItem from '../DepartmentItem';
import ExamRequires from '../ExamRequires';

const StyledSegment = styled(Segment)`
  /* max-width: 400px; */
`;

const mapDeptConverter = (data, isMini) => {
  if (isMini) {
    const filteredData = _.cloneDeep(data);
    delete filteredData.rounds;
    delete filteredData.roundSeats;
    return deptConverter(
      filteredData,
      filteredData.faculty,
      filteredData.faculty && filteredData.faculty.university,
    );
  }
  return deptConverter(data, data.faculty, data.faculty && data.faculty.university);
};

export class RoundDetails extends Component {
  render() {
    const { rounds, score, scoresList } = this.props;
    const shouldShowScoreOnRound3 = score && score.scoreType === 'MEDS';
    const round3 = rounds[2];
    const round4 = rounds[3];
    // console.log(roundDetails, round3, round4);
    const tcasIdsRound3 = _.compact([...round3]);
    const tcasIdsRound4 = _.compact([...round4]);
    const inScoresList = scoresList.length > 0 ? scoresList.map(convertScore) : undefined;
    return (
      <Fragment>
        {tcasIdsRound3.map(tcas => (
          <Box key={tcas.id} mt={4}>
            <ExamRequires
              tcasId={tcas.id}
              scores={
                shouldShowScoreOnRound3 && !inScoresList === 0 ? convertScore(score || {}) : null
              }
              scoresList={shouldShowScoreOnRound3 ? inScoresList : null}
              enableScoreCalc
            />
          </Box>
        ))}
        {tcasIdsRound4.map(tcas => (
          <Box key={tcas.id} mt={4}>
            <ExamRequires
              tcasId={tcas.id}
              scores={!shouldShowScoreOnRound3 && !inScoresList ? convertScore(score || {}) : null}
              scoresList={!shouldShowScoreOnRound3 ? inScoresList : null}
              enableScoreCalc
            />
          </Box>
        ))}
      </Fragment>
    );
  }
}

export default class DepartmentCard extends Component {
  static propTypes = {
    data: PropTypes.shape({}),
  };

  componentDidCatch(error, info) {
    log.error(error);
  }

  render() {
    const { data, depId, variant, onSelectDeparmentId } = this.props;

    if (data) {
      const { admissionRounds = [], score, scoreY1, scoreY2 } = data;
      const scoresList = [];
      if (score) scoresList.push(score);
      if (scoreY1) scoresList.push(scoreY1);
      if (scoreY2) scoresList.push(scoreY2);

      const isSelectMode = variant === 'select-mode';
      const isMini = variant === 'mini';

      return (
        <StyledSegment>
          <Flex flexWrap="wrap">
            <Box width={1}>
              <DepartmentItem
                {...mapDeptConverter(data, isMini || isSelectMode)}
                // favDisabled={isMini}
                isSelectMode={isSelectMode}
                isConfirmedAdmission={isMini}
                onSelectDeparmentId={onSelectDeparmentId}
              />
              {!isMini && !isSelectMode && admissionRounds.length > 4 && (
                <RoundDetails rounds={admissionRounds} score={score} scoresList={scoresList} />
              )}
            </Box>
          </Flex>
        </StyledSegment>
      );
    } else {
      return (
        <StyledSegment>
          <Flex flexWrap="wrap">
            <Box width={1}>
              <DepartmentItem id={depId} notFound={true} />
            </Box>
          </Flex>
        </StyledSegment>
      );
    }
  }
}
